import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType, act } from '@ngrx/effects';
import {
  switchMap,
  map,
  mergeMap,
  catchError,
  exhaustMap,
  concatMap,
} from 'rxjs/operators';
import { of } from 'rxjs';

import {
  loadPipelines,
  loadPipelinesSuccess,
  refreshPipelines,
  createPipelines,
  createPipelinesSuccess,
  updatePipelines,
  updatePipelinesSuccess,
  deletePipelines,
  deletePipelinesSuccess,
  createPipelinesError,
  updatePipelinesError,
  deletePipelinesError,
} from '../actions/pipeline.action';
import { PipelineService } from '../services/pipeline.service';

@Injectable()
export class PipelineEffect {
  loadPipelines$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPipelines),
      switchMap(({ pagination }) =>
        this.pipelineService.getPipelines(pagination)
      ),
      map(res => {
        return loadPipelinesSuccess({ ...res });
      })
    )
  );

  createPipelines$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createPipelines),
      switchMap(action => this.pipelineService.createPipeline(action.pipeline)),
      map(res => createPipelinesSuccess()),
      catchError(err =>
        of(
          createPipelinesError({
            error: err,
          })
        )
      )
    )
  );

  updatePipelines$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updatePipelines),
      switchMap(action => this.pipelineService.updatePipeline(action.pipeline)),
      map(res => updatePipelinesSuccess()),
      catchError(err =>
        of(
          updatePipelinesError({
            error: err,
          })
        )
      )
    )
  );

  deletePipelines$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deletePipelines),
      switchMap(action => this.pipelineService.deletePipeline(action.pipeline)),
      map(res => deletePipelinesSuccess()),
      catchError(err =>
        of(
          deletePipelinesError({
            error: err,
          })
        )
      )
    )
  );

  refreshPipelines = createEffect(() =>
    this.actions$.pipe(
      ofType(refreshPipelines),
      switchMap(action =>
        of(
          loadPipelines({
            pagination: null,
            activePagination: action.pagination,
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private pipelineService: PipelineService
  ) {}
}
